var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp_sangforLogo"},[_c('div',{staticClass:"sp_logo_top",class:{active:_vm.activeIndex==3}},[_c('img',{attrs:{"src":require("@a/img/sangfor.png"),"alt":"SANGFOR"}}),(_vm.activeIndex == 3)?_c('div',{staticClass:"active-three"},[_c('span',{staticClass:"line"}),_c('h3',[_vm._v("Sangfor Support Portal")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }